import { computePosition, autoUpdate, offset, flip, shift } from "@floating-ui/dom"

globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.Dropdown = (function () {

  Dropdown.selector = '[data-toggle="dropdown"]';

  Dropdown.init = function ($html) {
    $html.find(Dropdown.selector).each(function () {
      new Dropdown($(this));
    })
  }

  function Dropdown($toggle) {
    this.$toggle = $toggle;
    this.$parent = $toggle.parent();
    this._cleanup = null;
    this._originalStyles = null;
    this.init();
  }

  Dropdown.prototype = {
    init: function () {
      if (this.$toggle.data('floating-dropdown-init')) return;
      this.$toggle.data('floating-dropdown-init', true);

      var dropdown = this;

      this.$parent.on('shown.bs.dropdown', function () {
        dropdown.show();
      });

      this.$parent.on('hidden.bs.dropdown', function () {
        dropdown.hide();
      });
    },

    show: function () {
      var $menu = this.$parent.find('.dropdown-menu');
      if (!$menu.length) return;

      var referenceEl = this.$toggle[0];
      var floatingEl = $menu[0];

      var isDropup = this.$parent.hasClass('dropup');
      var isRight = $menu.hasClass('dropdown-menu-right');
      var basePlacement = isDropup ? 'top' : 'bottom';
      var alignment = isRight ? 'end' : 'start';
      var placement = basePlacement + '-' + alignment;

      this._originalStyles = {
        position: floatingEl.style.position,
        top: floatingEl.style.top,
        left: floatingEl.style.left,
        right: floatingEl.style.right,
        bottom: floatingEl.style.bottom,
        margin: floatingEl.style.margin,
        width: floatingEl.style.width
      };

      Object.assign(floatingEl.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        right: 'auto',
        bottom: 'auto',
        margin: '0'
      });

      if ($menu.hasClass('full-width')) {
        floatingEl.style.width = referenceEl.offsetWidth + 'px';
      }

      var dropdown = this;

      function updatePosition() {
        computePosition(referenceEl, floatingEl, {
          placement: placement,
          strategy: 'fixed',
          middleware: [offset(2), flip(), shift({ padding: 8 })]
        }).then(function (result) {
          Object.assign(floatingEl.style, {
            left: result.x + 'px',
            top: result.y + 'px'
          });
        });
      }

      this._cleanup = autoUpdate(referenceEl, floatingEl, updatePosition);
    },

    hide: function () {
      if (this._cleanup) {
        this._cleanup();
        this._cleanup = null;
      }

      var $menu = this.$parent.find('.dropdown-menu');
      if ($menu.length && this._originalStyles) {
        Object.assign($menu[0].style, this._originalStyles);
        this._originalStyles = null;
      }
    }
  }

  return Dropdown;

})();
